/**
 * A function that does nothing.
 *
 * @see {@link https://en.wikipedia.org/wiki/NOP_(code)|Wikipedia}
 */
export function noop () { }
